import { Users } from '@or-sdk/users';

import { useAuthStore } from '@/stores/auth/auth';
import { sdkApiUrl } from '@/utils/authUiRuntime';

import config from '../config';

export default new Users({
  token: () => useAuthStore().reactiveToken as string,
  usersUrl: config.USERS_API_URL,
  sdkUrl: sdkApiUrl,
});
